const validateFrenchCNI = (id: string): boolean => {
  // French CNI format: 9 or 12 alphanumeric characters
  const CNI_REGEX = /^[a-zA-Z0-9]{9}$|^[a-zA-Z0-9]{12}$/

  if (!id || id.length === 0) {
    return false
  }

  return CNI_REGEX.test(id)
}

export default validateFrenchCNI
